import React, { FC, ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';
import VideoPlayerPopup from './VideoPlayerPopup';
import {
    SOCIAL_MEDIA_FACEBOOK,
    SOCIAL_MEDIA_INSTAGRAM,
    SOCIAL_MEDIA_TWITTER,
    SOCIAL_MEDIA_YOUTUBE,
    SocialMediaLink
} from '../common/SocialMediaLink';
import { useNeverShowTutorialAgain } from '../product/detail/api/useNeverShowTutorialAgain';
import { Trans, useTranslation } from 'react-i18next';
import { LanguageSelector } from '../header/LanguageSelector';
import { LOCALISATION, useFeature } from '../utils/togglz';
import { useIsAdmin } from '../utils';
import { LANGUAGE_DE_DE } from '../../../i18n';
import { loadTutorialCookie, saveTutorialCookie } from '../../app-store/authentication/auth-utils';

const Footer: FC = () => {
    const {
        t,
        i18n: { language }
    } = useTranslation();
    const [showIntroVideo, setShowIntroVideo] = useState(loadTutorialCookie().showIntroVideo);
    const showReserveVideo = loadTutorialCookie().showReserveVideo;
    const [showTutorialFromLink, setShowTutorialFromLink] = useState(false);
    const { mutate: neverShowTutorialMutation } = useNeverShowTutorialAgain();
    const isLocalisationEnabled = useFeature(LOCALISATION);
    const isAdmin = useIsAdmin();

    function hideTutorialVideo(neverShowAgain = true) {
        if (showIntroVideo) {
            setShowIntroVideo(false);
            saveTutorialCookie({ showReserveVideo, showIntroVideo: false });
            if (neverShowAgain && showIntroVideo) {
                neverShowTutorialMutation();
            }
        } else {
            setShowTutorialFromLink(false);
        }
    }

    function showTutorialVideo() {
        setShowTutorialFromLink(true);
    }

    const socialMediaChannels = [
        SOCIAL_MEDIA_FACEBOOK,
        SOCIAL_MEDIA_TWITTER,
        SOCIAL_MEDIA_INSTAGRAM,
        SOCIAL_MEDIA_YOUTUBE
    ];
    const socialMediaLinks: ReactNode[] = [];
    socialMediaChannels.forEach((channel, index) => {
        const channelValues = channel as 'Facebook' | 'Instagram' | 'X' | 'YouTube';
        return socialMediaLinks.push(
            <li key={index}>
                <SocialMediaLink channel={channelValues} />
            </li>
        );
    });

    const VideoIcon = () => {
        return <i className="material-icons">play_circle_outline</i>;
    };

    return (
        <div className="page-footer" data-displayname="Footer">
            <div className="col-logo" />
            <div className="col-mid">
                {language !== LANGUAGE_DE_DE ? (
                    <a onClick={() => showTutorialVideo()}>
                        <Trans i18nKey="components.footer.replayIntroductionVideo" components={{ 1: <VideoIcon /> }} />
                    </a>
                ) : null}
                <VideoPlayerPopup
                    title={t('components.footer.introductionVideoModalTitle')}
                    description={t('components.footer.introductionVideoModalSubtitle')}
                    showVideo={(showIntroVideo || showTutorialFromLink) && language !== LANGUAGE_DE_DE}
                    hideVideo={hideTutorialVideo}
                    vimeoId={218575468}
                    isTutorialVideoEntryPage={loadTutorialCookie().showIntroVideo}
                />
            </div>
            <div className="col-right">
                <div>{t('components.footer.followUs')}</div>
                <ul className="social-media-links">{socialMediaLinks}</ul>
                <div className="copyright">
                    {t('components.footer.copyRight', {
                        currentDate: new Date().getFullYear()
                    })}
                </div>
                {isLocalisationEnabled && isAdmin ? (
                    <div className="footer-right-container">
                        <Link className="terms-and-conditions-link" to={'/terms-conditions'}>
                            {t('components.footer.termsAndConditions')}
                        </Link>
                        <div className="footer-bar">|</div>
                        <div className="language">
                            <LanguageSelector />{' '}
                        </div>
                    </div>
                ) : (
                    <Link className="terms-and-conditions-link" to={'/terms-conditions'}>
                        {t('components.footer.termsAndConditions')}
                    </Link>
                )}
            </div>
        </div>
    );
};

export default Footer;
